import { Routes } from '@/router/routes'

import { AppPermissions } from '@/types/enums/permissions/permissions'
import { Middleware } from '@/types/enums/middleware/middleware'

export const trainingRoutes = [
  {
    path: '/training',
    name: Routes.Training,
    component: () => import('@/pages/contexts/portal/training/Index.vue'),
    meta: {
      pageTitle: 'Manage Training',
      middleware: [
        Middleware.REQUIRES_AUTH,
        Middleware.TOGGLES_NAV_DRAWER,
      ],
      permission: AppPermissions.VIEW_TRAINING,
    },
    children: [
      {
        path: 'create',
        name: Routes.TrainingCreate,
        component: () => import('@/pages/contexts/portal/training/Create.vue'),
        meta: {
          middleware: [
            Middleware.REQUIRES_AUTH,
            Middleware.TOGGLES_NAV_DRAWER,
          ],
          permission: AppPermissions.MANAGE_TRAINING,
        },
      },
      {
        path: 'edit/:trainingId',
        name: Routes.TrainingEdit,
        component: () => import('@/pages/contexts/portal/training/Edit.vue'),
        meta: {
          middleware: [
            Middleware.REQUIRES_AUTH,
            Middleware.TOGGLES_NAV_DRAWER,
          ],
          permission: AppPermissions.MANAGE_TRAINING,
        },
      },
    ],
  },
  {
    path: '/training/staff',
    name: Routes.TrainingStaffList,
    component: () => import('@/pages/contexts/portal/training/staff/Index.vue'),
    meta: {
      pageTitle: 'Staff Training Logs',
      middleware: [
        Middleware.REQUIRES_AUTH,
        Middleware.TOGGLES_NAV_DRAWER,
      ],
      permission: AppPermissions.VIEW_TRAINING,
    },
  },
  {
    path: '/training/staff/:staffId',
    name: Routes.TrainingStaffLogs,
    component: () => import('@/pages/contexts/portal/training/staff/_staffId/Index.vue'),
    meta: {
      pageTitle: 'Training Logs',
      middleware: [
        Middleware.REQUIRES_AUTH,
        Middleware.TOGGLES_NAV_DRAWER,
      ],
      permission: AppPermissions.VIEW_TRAINING,
    },
    children: [
      {
        path: 'create',
        name: Routes.TrainingStaffLogsCreate,
        component: () => import('@/pages/contexts/portal/training/staff/_staffId/Create.vue'),
        meta: {
          middleware: [
            Middleware.REQUIRES_AUTH,
            Middleware.TOGGLES_NAV_DRAWER,
          ],
          permission: AppPermissions.VIEW_TRAINING,
        },
      },
    ],
  },
]
